"use client";

import { TeamMemberCard, TeamMemberMorphContext } from "@entities/team-member";
import { Pages } from "@shared/api";
import { useScrollStartAtTop } from "@shared/lib/scroll-start-at-top";
import { Header } from "@shared/ui/header";
import { RichText } from "@shared/ui/rich-text";
import { useTranslations } from "next-intl";
import { useContext } from "react";
import { useInView } from "react-intersection-observer";

export default function Page() {
  useScrollStartAtTop();

  const t = useTranslations(Pages.TeamMembers as never);

  const { ref, inView } = useInView({
    threshold: 0,
    initialInView: true,
    triggerOnce: true,
  });

  const { morphs, enabled, teamMembers } = useContext(TeamMemberMorphContext);

  return (
    <div ref={ref} className={"flex flex-col gap-8"}>
      <Header title={"Time"} />

      <span
        className={`text-black-pearl-950 text-center text-lg xl:px-72 ${inView ? "animate-fade-in" : "animate-fade-out opacity-0"}`}
      >
        <RichText message={t.raw("texts.team_top.content")} />
      </span>

      <div
        className={`flex flex-wrap justify-center w-full gap-4 mt-16 ${inView ? "animate-fade-in" : "animate-fade-out opacity-0"}`}
      >
        {teamMembers.map((teamMember, index) => (
          <TeamMemberCard
            key={index}
            teamMember={teamMember}
            selectable={true}
            className={"w-full lg:w-[24rem] xl:w-[22rem]"}
            {...(enabled && morphs[index])}
          />
        ))}
      </div>
    </div>
  );
}
